import { styled } from "@mui/material";

export const StyledGridFormingUnitRowForSwitchingOperationCheckbox = styled("div", {
  name: "StyledGridFormingUnitRowForSwitchingOperationCheckbox",
  shouldForwardProp: (propName) => propName !== "isSingle",
})<{ isSingle: boolean }>(({ theme, isSingle }) => ({
  display: "flex",

  width: "100%",
  height: "59px",
  padding: "0px 32px",
  [theme.breakpoints.down("xxxl")]: {
    flexDirection: "column",
    height: isSingle ? "59px" : "118px",
  },
  "@media (max-width: 1200px)": { height: "auto" },
}));
